import React from 'react';
import PropTypes from 'prop-types';

const Text = ({ value = '' }) => <span>{value}</span>;

Text.propTypes = { value: PropTypes.string };

export default Text;
